import envConfig from 'configs/envConfig';
import { SERVICE_PROVIDER } from 'configs/fetchApi';

/**
 * @typedef {Object} SettingsType
 * @property {string} method
 * @property {Object} headers
 * @property {Object} body
 */

/**
 * settings
 * @param {string} uri
 * @param {SettingsType} settings
 * @returns response
 */

/**
 * callFetch
 * @param {string} key
 * @returns
 */

export function callStoreFetch(storeName, funcName) {
    return (uri, settings) => ({
        key: funcName,
        storeKey: SERVICE_PROVIDER.SEVER, // store in apiProvider
        storeName,
        callback: () =>
            fetch(`${envConfig.API_HOST}${uri}`, settings)
                .then((response) => {
                    if (response.ok) return response.json();
                    return response.text().then((text) => {
                        throw Error(text);
                    });
                })
                .catch((error) => {
                    console.error(error);
                    return { err: true, message: error.message };
                })
    });
}

export function callFetch(uri, settings) {
    return fetch(`${envConfig.API_HOST}${uri}`, settings)
        .then((response) => {
            if (response.ok) return response.json();
            return response.text().then((text) => {
                throw Error(text);
            });
        })
        .catch((error) => {
            console.error(error, settings, uri);
            let message = '發生錯誤';
            try {
                const resp = JSON.parse(error.message);
                message = resp.message;
            } catch (_error) {}

            return { err: true, message };
        });
}
